import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import logo from "../images/logo.svg";
import styles from "./Navbar.css";
import {
  ConnectWallet,
  MediaRenderer,
  darkTheme,
  useActiveClaimCondition,
  useContract,
  useContractMetadata,
  useContractRead,
} from "@thirdweb-dev/react";
// import styles from './Mint.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolling = window.scrollY > 0;
      setIsSticky(isScrolling);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const customTheme = darkTheme({
    fontFamily: "'Teko'",
    colors: {
      modalBg: "#000",
      primaryText: "#333333",
      walletSelectorButtonHoverBg: "#EEEEEE",
      separatorLine: "#000000",
      borderColor: "#000000",
      accentButtonText: "#141452",
      // primaryButtonBg: "transparent",
    },
  });

  const { contract } = useContract(
    "0xA05803e679f517cFD9f20031816aB57A7b2Fc2d3"
  );
  const { data: contractMetadata } = useContractMetadata(contract);

  const { data: totalSupply } = useActiveClaimCondition(contract, 0);
  const { data: contractRead } = useContractRead(contract, "totalSupply");

  return (
    <section className={`Navbar${isSticky ? " sticky" : ""}`}>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <img src={logo} alt="Logo" className="navbar-brand" />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded={isMenuOpen ? "true" : "false"}
            onClick={handleMenuToggle}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`offcanvas offcanvas-end ${isMenuOpen ? "show" : ""}`}
            id="navbarText"
            tabIndex="-1"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title">Menu</h5>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleCloseMenu}
              ></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link
                    to="about"
                    spy={true}
                    smooth={true}
                    duration={500}
                    onClick={handleCloseMenu}
                    className="nav-link"
                    style={{ fontFamily: "'Teko', sans-serif" }}
                  >
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="roadmap"
                    spy={true}
                    smooth={true}
                    duration={500}
                    onClick={handleCloseMenu}
                    className="nav-link"
                    style={{ fontFamily: "'Teko', sans-serif" }}
                  >
                    Ecosystem
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="team"
                    spy={true}
                    smooth={true}
                    duration={500}
                    onClick={handleCloseMenu}
                    className="nav-link"
                    style={{ fontFamily: "'Teko', sans-serif" }}
                  >
                    Team
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="collection"
                    spy={true}
                    smooth={true}
                    duration={500}
                    onClick={handleCloseMenu}
                    className="nav-link"
                    style={{ fontFamily: "'Teko', sans-serif" }}
                  >
                    Tribes
                  </Link>
                </li>
                {/* <li className="nav-item">
                  <a
                    href="https://mint_hoodrats.ar-io.dev/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleCloseMenu}
                    className="nav-link"
                    style={{ fontFamily: "'Teko', sans-serif" }}
                  >
                    Mint
                  </a>
                 </li> */}
                <li className="nav-item">
                  <ConnectWallet
                    btnTitle="Connect"
                    className="connectButton"
                    theme={customTheme}
                    modalTitle="HOODRATS WEB3 MODAL"
                    modalTitleIconUrl="/01.png"
                    switchToActiveChain={true}
                    welcomeScreen={() => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "100px",
                          }}
                        >
                          <h2>Mint @ 0.025ETH</h2>
                          <iframe
                            title="HR TBA iframe"
                            className="flex w-full max-w-lg flex-col space-y-4"
                            src="https://iframe-tokenbound.vercel.app/0xa05803e679f517cfd9f20031816ab57a7b2fc2d3/218/1"
                            style={{
                              height: "350px",
                              width: "350px",
                              border: "4px solid #000",
                            }}
                          />
                          {/* <img 
                            style={{
                              height: "350px",
                              width: "380px"
                            }}
                            src='https://iframe-tokenbound.vercel.app/0xa05803e679f517cfd9f20031816ab57a7b2fc2d3/251/1' /> */}
                          {/* <MediaRenderer 
                              src={"https://arweave.net/KZ8ni5LqSnu-i5fT6WUnje4u-Va0J2…OBOM/6c49918fc44637e13acec6462a12525326bc9ce1.png"}
                              width="175%"
                            /> */}
                          <p>Connect To Mint</p>
                          <h3>
                            {" "}
                            <span
                              style={{
                                fontSize: "2rem",
                                fontColor: "red",
                              }}
                            >
                              {contractRead?.toNumber()}
                            </span>
                            /10,000 Minted
                          </h3>
                        </div>
                      );
                    }}
                  />
                </li>
              </ul>
              <div className="d-flex align-items-center ms-lg-4">
                <a href="https://twitter.com/HoodRatNFTs" className="btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 512 512"
                    fill="currentColor"
                  >
                    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                  </svg>
                </a>
                <a
                  href="https://opensea.io/collection/hood-rats"
                  className="btn"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="bi bi-discord"
                  >
                    <title>OpenSea</title>
                    <path d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.629 0 12 0ZM5.92 12.403l.051-.081 3.123-4.884a.107.107 0 0 1 .187.014c.52 1.169.972 2.623.76 3.528-.088.372-.335.876-.614 1.342a2.405 2.405 0 0 1-.117.199.106.106 0 0 1-.09.045H6.013a.106.106 0 0 1-.091-.163zm13.914 1.68a.109.109 0 0 1-.065.101c-.243.103-1.07.485-1.414.962-.878 1.222-1.548 2.97-3.048 2.97H9.053a4.019 4.019 0 0 1-4.013-4.028v-.072c0-.058.048-.106.108-.106h3.485c.07 0 .12.063.115.132-.026.226.017.459.125.67.206.42.636.682 1.099.682h1.726v-1.347H9.99a.11.11 0 0 1-.089-.173l.063-.09c.16-.231.391-.586.621-.992.156-.274.308-.566.43-.86.024-.052.043-.107.065-.16.033-.094.067-.182.091-.269a4.57 4.57 0 0 0 .065-.223c.057-.25.081-.514.081-.787 0-.108-.004-.221-.014-.327-.005-.117-.02-.235-.034-.352a3.415 3.415 0 0 0-.048-.312 6.494 6.494 0 0 0-.098-.468l-.014-.06c-.03-.108-.056-.21-.09-.317a11.824 11.824 0 0 0-.328-.972 5.212 5.212 0 0 0-.142-.355c-.072-.178-.146-.339-.213-.49a3.564 3.564 0 0 1-.094-.197 4.658 4.658 0 0 0-.103-.213c-.024-.053-.053-.104-.072-.152l-.211-.388c-.029-.053.019-.118.077-.101l1.32.357h.01l.173.05.192.054.07.019v-.783c0-.379.302-.686.679-.686a.66.66 0 0 1 .477.202.69.69 0 0 1 .2.484V6.65l.141.039c.01.005.022.01.031.017.034.024.084.062.147.11.05.038.103.086.165.137a10.351 10.351 0 0 1 .574.504c.214.199.454.432.684.691.065.074.127.146.192.226.062.079.132.156.19.232.079.104.16.212.235.324.033.053.074.108.105.161.096.142.178.288.257.435.034.067.067.141.096.213.089.197.159.396.202.598a.65.65 0 0 1 .029.132v.01c.014.057.019.12.024.184a2.057 2.057 0 0 1-.106.874c-.031.084-.06.17-.098.254-.075.17-.161.343-.264.502-.034.06-.075.122-.113.182-.043.063-.089.123-.127.18a3.89 3.89 0 0 1-.173.221c-.053.072-.106.144-.166.209-.081.098-.16.19-.245.278-.048.058-.1.118-.156.17-.052.06-.108.113-.156.161-.084.084-.15.147-.208.202l-.137.122a.102.102 0 0 1-.072.03h-1.051v1.346h1.322c.295 0 .576-.104.804-.298.077-.067.415-.36.816-.802a.094.094 0 0 1 .05-.03l3.65-1.057a.108.108 0 0 1 .138.103z" />
                  </svg>
                </a>
                <a href="https://discord.gg/8NprDwRf2n" className="btn">
                  <i className="bi bi-discord"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </section>
  );
}

export default Navbar;
